import { useState } from "react";
import { updateInvoice } from "../../api/invoiceService";

export const useUpdateInvoice = (successCallback) => {
  const [updating, setUpdating] = useState(false);
  const update = async (id, data) => {
    setUpdating(true);
    try {
      const updatedRecord = await updateInvoice(id, data);
      setUpdating(false);
      if (successCallback) successCallback(updatedRecord);
      return updatedRecord;
    } catch (error) {
      setUpdating(false);
      console.error("Failed to update invoice:", error);
      throw error;
    }
  };

  return { update, updating };
};